
import React, { memo } from "react";
import { MoviesByDirector } from "@/types/movie";
import DirectorSectionItem from "./DirectorSectionItem";

interface DirectorSectionListProps {
  directors: string[];
  moviesByDirector: MoviesByDirector;
  currentTab: string;
  viewMode: "grid" | "list";
  onOpenMovieDetails?: (tmdbId: number) => void;
}

// Using memo to optimize rendering
const DirectorSectionList = memo<DirectorSectionListProps>(({ 
  directors, 
  moviesByDirector, 
  currentTab,
  viewMode,
  onOpenMovieDetails
}) => {
  return (
    <div className="space-y-8 md:space-y-10 lg:space-y-12">
      {directors.map((director) => (
        <DirectorSectionItem
          key={director}
          directorName={director}
          movies={moviesByDirector[director]}
          currentTab={currentTab}
          viewMode={viewMode}
          onOpenMovieDetails={onOpenMovieDetails}
        />
      ))}
    </div>
  );
});

DirectorSectionList.displayName = "DirectorSectionList";

export default DirectorSectionList;
